import envData from 'env.json';
import {Platform} from 'react-native';

const {API_URL} = envData;

export function getMFAHomeURL(forwardUrl: string): string {
  return Platform.OS === 'web'
    ? `/a/verification/opt-in?forwardUrl=${forwardUrl}&amIAllowed=true`
    : `${API_URL}/a/verification/opt-in?forwardUrl=${forwardUrl}&amIAllowed=true`;
}

export function getMFAPreferenceURL(forwardUrl: string): string {
  return Platform.OS === 'web'
    ? `/a/verification/preference?forwardUrl=${forwardUrl}&amIAllowed=true`
    : `${API_URL}/a/verification/preference?forwardUrl=${forwardUrl}&amIAllowed=true`;
}

export const profileTabForwardUrl = '/rewards/profile%3Ftab%3Dprofile';
export const securityTabForwardUrl = '/rewards/profile%3Ftab%3Dsecurity';
export const paymentsTabforwardUrl = '/rewards/profile%3Ftab%3Dpayments';
